import * as React from "react";
import { Columns } from "../item/columns";
import { $, merge } from "glamor";
import ViewBase from "./base";
import Image from "../item/image";
import { rawTheme } from "styles/theme";

const ACTION_FIELD_WIDTH = 50;
const BULK_SELECTOR_FIELD_WIDTH = 40;
const PRICE_FIELD_WIDTH = 100;
const ITEM_HEIGHT = 50;

interface ICatalogDateProp {
    ship_start: number;
    ship_end: number;
}
interface IItemListViewProps {
    item: any;
    catalogEntry: any;
    catalogDates?: ICatalogDateProp;
    view: any;
    editable: boolean;
    scope: any;
    showActions: boolean;
    bulkItems: any;
    app: any;
    actionsOffset?: any;
}

class ItemListView extends React.Component<IItemListViewProps, any> {
    static height = ITEM_HEIGHT;
    static priceFieldWidth = PRICE_FIELD_WIDTH;
    static actionFieldWidth = ACTION_FIELD_WIDTH;
    static bulkSelectorFieldWidth = BULK_SELECTOR_FIELD_WIDTH;

    static styles = merge(
        $(" .item", {
            height: `${ITEM_HEIGHT}px`,
            width: "100%",
        }),
        $(" .bulkSelector", {
            width: `${BULK_SELECTOR_FIELD_WIDTH}px`,
            minWidth: `${BULK_SELECTOR_FIELD_WIDTH}px`,
        }),
        $(" .hover", {
            height: `${ITEM_HEIGHT - 1}px !important`,
            backgroundColor: `${rawTheme.palette.canvasColor} !important`,
        }),
        $(" .unavailableProduct", {
            position: "absolute",
            width: "100%",
            backgroundColor: rawTheme.palette.errorBackgroundColor,
            color: rawTheme.palette.errorColor,
            top: "0px",
            padding: "16px",
            fontSize: "14px",
            left: "48px",
        }),
    );

    declare renderBulkSelector: any;
    declare renderActions: any;

    render() {
        const { app, item, catalogEntry, catalogDates, view, scope, showActions, bulkItems } = this.props;
        const { hover } = this.state;
        const showImages = item && view && view.sections.get("small_image") && bulkItems && !hover && !app.touchDevice;
        const pricePerSize = scope.brand.hasPreference("price_per_size");
        return (
            <article>
                <div className="bulkSelector">
                    {showImages && <Image item={item} scope={scope} view={view} />}
                    {this.renderBulkSelector()}
                </div>
                <div>
                    <Columns
                        item={item}
                        view={view}
                        scope={scope}
                        catalogEntry={catalogEntry}
                        catalogDates={catalogDates}
                        priceFieldStyle={{ minWidth: `${pricePerSize ? PRICE_FIELD_WIDTH * 2 : PRICE_FIELD_WIDTH}px` }}
                    />
                </div>
                {item && view && showActions && this.renderActions(2)}
                {item && item.__out_of_range && catalogEntry && (
                    <div className="unavailableProduct">{catalogEntry.unavailableProductWarning(scope)}</div>
                )}
            </article>
        );
    }
}

export default ViewBase(ItemListView);
